import { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

// A password field with the eye that shows what has been typed.
//
// Every password input in the portal uses this: a typo in a masked field cannot
// be seen, and on a sign-in or a reset the person is left guessing which of the
// two passwords was wrong. Showing it is the cheapest way to stop that, and it
// is what makes "check before you submit" possible at all.
//
// Props pass straight through to the TextField, so a field keeps its own size,
// spacing, validation and labels; an endAdornment of its own, if it ever has
// one, is kept and the eye appended after it.
const PasswordField = ({ disabled, InputProps, ...props }: any) => {
  const [shown, setShown] = useState(false);

  return (
    <TextField
      {...props}
      disabled={disabled}
      type={shown ? "text" : "password"}
      InputProps={{
        ...(InputProps || {}),
        endAdornment: (
          <>
            {InputProps?.endAdornment}
            <InputAdornment position="end">
              <IconButton
                size="small"
                edge="end"
                disabled={disabled}
                // Keeps focus on the field: without this, clicking the eye
                // takes the caret out of the input it belongs to.
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => setShown((current) => !current)}
                aria-label={shown ? "Hide password" : "Show password"}
                title={shown ? "Hide password" : "Show password"}
              >
                {shown ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          </>
        ),
      }}
    />
  );
};

export default PasswordField;
